export default{
	timestampConversion(timestamp){
		var date=new Date(timestamp*1000);
		return date.getFullYear()+"."+(date.getMonth()+1)+"."+date.getDate();
	},
	timestampToText(timestamp){
		var nowTimestamp=new Date().getTime()/1000;
		var str="";
		var difference=nowTimestamp-timestamp;
		//用当前减去参数 大于0表示在之前 小于0表示在之后
		if(difference>0){
			if(difference<60){
				str="刚刚";
			}
			else if(difference>=60 && difference<3600){
				str=parseInt(difference/60)+"分钟前";
			}
			else if(difference>=3600 && difference<86400){
				str=parseInt(difference/3600)+"小时前";
			}
			else{
				str=parseInt(difference/86400)+"天前";
			}
		}
		else{
			difference*=-1;
			if(difference<60){
				str="即将";
			}
			else if(difference>=60 && difference<3600){
				str=parseInt(difference/60)+"分钟后";
			}
			else if(difference>=3600 && difference<86400){
				str=parseInt(difference/3600)+"小时后";
			}
			else{
				str=parseInt(difference/86400)+"天后";
			}
		}
		return str;
	},
	getCookie(name){//读取cookie
	  var arr;
	  var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	  if (arr = document.cookie.match(reg))
	    return decodeURIComponent(arr[2]);
	  else
	  	return null;
	},
  setCookie(name, value, hours) {
    var d = new Date();
    d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + "; " + expires+"; path=/";
  },
  setStorage(key, value, expiryInMinutes){
    const now = new Date().getTime() / 1000;
    const item = {
      value: value,
      expiry: now + Number(expiryInMinutes) // 过期时间（毫秒）
    };
    localStorage.setItem(key, JSON.stringify(item));
  },
  getStorage(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    const item = JSON.parse(itemStr);
    const now = new Date().getTime() / 1000;
    // 检查是否过期
    if (now > item.expiry) {
      localStorage.clear(); // 如果过期，删除该项
      return null;
    }
    return item.value;
  },
	HTMLDecode(str){
		var code={
			"&ensp;":" ",
			"&emsp;":" ",
			"&nbsp;":" ",
			"&lt;":"<",
			"&gt;":">",
			"&amp;":"&",
			"&quot;":"\"",
			"&copy;":"©",
			"&reg;":"®",
			"&times;":"×",
			"&divide;":"÷"
		};
		var codeArr=[];
		for(var i in code){
			codeArr.push(i);
		}
		str=str.replace(new RegExp(codeArr.join("|"),"gim"),function(catchStr){
			return code[catchStr];
		})
		return str;
	},
  //html去掉标签
	removeHTML(str){
		return str.replace(/<.*?>/gim,"");
	},
  //如果参数2在参数1中，返回true，否则返回false
  has(parent,el){
    var currentEl=el;
    //只要currentEl不是document，就比较并赋值为其父元素
    while(currentEl.nodeType!==9){
      if(currentEl===parent){
        return true;
      }
      currentEl=currentEl.parentNode;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/util/tools.js